// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pointer[data-v-b72e40f4] {\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
